import React from 'react';
import ReactQuill from 'react-quill';
import PropTypes from 'prop-types';

const Editor = (props) => {
  const handleChange = (html) => {
    if(html == '<br>')
      props.setDescription('');
    else
      props.setDescription(html);
  };

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline']
    ]
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
  ];

  React.useEffect(() => {
    const quillContainer = document.querySelector('.ql-container.ql-snow');
    if (quillContainer) {
      quillContainer.style.minHeight = '200px';
      quillContainer.style.maxHeight = '450px';
      quillContainer.style.overflowY = 'scroll';
    }
  }, []);
  

  return (
    <>
      <ReactQuill
        onChange={handleChange}
        theme="snow"
        modules={modules}
        formats={formats}
        value={props.description}
        placeholder='Type here...'
      />
    </>
  );
};

Editor.propTypes = {
  description: PropTypes.string,
  setDescription: PropTypes.function
};

export default Editor;
